const downloadFile = (data, file_name, mimetype) => {
  const blob = new Blob([data], {
    type: mimetype
  });
  const a = document.createElement('a');
  a.download = file_name;
  a.href = URL.createObjectURL(blob);
  a.addEventListener('click', () => {
    setTimeout(() => URL.revokeObjectURL(a.href), 30 * 1000);
  });
  a.click();
};
export default downloadFile;